/* ==========================================================================
   Scenario Landing Page Scripts
   ========================================================================== */

(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     Utility: attach horizontal touch-swipe handlers to an element.
     onSwipe receives -1 (swipe right → prev) or +1 (swipe left → next).
     -------------------------------------------------------------------------- */
  function attachSwipe(el, onSwipe) {
    if (!el) return;
    var startX = 0, startY = 0, tracking = false;
    var THRESHOLD = 50; // px

    el.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) { tracking = false; return; }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    el.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = (e.changedTouches && e.changedTouches[0]) || null;
      if (!t) return;
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > THRESHOLD) {
        onSwipe(dx < 0 ? 1 : -1);
      }
    }, { passive: true });

    el.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });
  }

  /* --------------------------------------------------------------------------
     Utility: simple carousel helper
     Returns a controller: { goTo(index), next(), pause(), resume() }
     -------------------------------------------------------------------------- */
  function createCarousel(options) {
    var track = options.track;
    var dots = options.dots || [];
    var total = options.total;
    var interval = options.interval || 3000;
    var current = 0;
    var timer = null;
    var onChange = options.onChange || null;

    function goTo(index) {
      current = (index + total) % total;
      if (track) {
        track.style.transform = 'translateX(-' + current * 100 + '%)';
      }
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
      if (onChange) onChange(current);
    }

    function next() {
      goTo(current + 1);
    }

    function start() {
      stop();
      timer = setInterval(next, interval);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    // Dot click
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        stop();
        start();
      });
    });

    goTo(0);
    start();

    return { goTo: goTo, next: next, pause: stop, resume: start };
  }

  /* --------------------------------------------------------------------------
     Section 2: Scene Carousel (tabs + auto-play)
     -------------------------------------------------------------------------- */
  function initSceneCarousel() {
    var sections = document.querySelectorAll('.scenario-scene');
    sections.forEach(function (section) {
      var tabs = section.querySelectorAll('.scenario-scene__tab');
      var slides = section.querySelectorAll('.scenario-scene__slide');
      var total = tabs.length;
      // Skip containers that don't have the legacy top-tab UI (e.g. scenario-gifting-tabs
      // section uses dots-only carousel, handled by initGiftingScenes below).
      if (total === 0) return;
      var current = 0;
      var timer = null;

      function showSlide(index) {
        current = (index + total) % total;
        tabs.forEach(function (tab, i) {
          tab.classList.toggle('is-active', i === current);
        });
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === current);
        });
      }

      function startTimer() {
        stopTimer();
        timer = setInterval(function () {
          showSlide(current + 1);
        }, 5000);
      }

      function stopTimer() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          showSlide(i);
          stopTimer();
          startTimer();
        });
      });

      showSlide(0);
      startTimer();
      section._sceneCarousel = { pause: stopTimer, resume: startTimer };
    });
  }

  /* --------------------------------------------------------------------------
     Section 3: Product Gallery Slider
     -------------------------------------------------------------------------- */
  function initProductGallery() {
    var galleries = document.querySelectorAll('.scenario-product-buy__gallery-col');
    galleries.forEach(function (gallery) {
      var track   = gallery.querySelector('.scenario-product-buy__gallery-track');
      var dotsEl  = gallery.querySelectorAll('.scenario-product-buy__gallery-dot');
      var prevBtn = gallery.querySelector('.scenario-product-buy__gallery-arrow--prev');
      var nextBtn = gallery.querySelector('.scenario-product-buy__gallery-arrow--next');
      var total   = gallery.querySelectorAll('.scenario-product-buy__gallery-slide').length;

      if (!track || total === 0) return;

      var currentIndex = 0;

      var ctrl = createCarousel({
        track: track,
        dots: Array.from(dotsEl),
        total: total,
        interval: 5000,
        onChange: function (index) {
          currentIndex = index;
        }
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          ctrl.goTo(currentIndex - 1);
          ctrl.pause();
          ctrl.resume();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          ctrl.goTo(currentIndex + 1);
          ctrl.pause();
          ctrl.resume();
        });
      }

      var swipeTarget = gallery.querySelector('.scenario-product-buy__gallery-track-wrap') || track;
      attachSwipe(swipeTarget, function (dir) {
        ctrl.goTo(currentIndex + dir);
        ctrl.pause();
        ctrl.resume();
      });
    });
  }

  /* --------------------------------------------------------------------------
     Section 3: Color Variant Toggle
     -------------------------------------------------------------------------- */
  function initColorVariants() {
    var containers = document.querySelectorAll('.scenario-product-buy__color-btns');
    containers.forEach(function (container) {
      var btns    = container.querySelectorAll('.scenario-product-buy__color-btn');
      var info    = container.closest('.scenario-product-buy__info');
      var section = container.closest('.scenario-product-buy');

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');

          var url           = btn.getAttribute('data-url');
          var variantId     = btn.getAttribute('data-variant-id');
          var price         = btn.getAttribute('data-price');
          var comparePrice  = btn.getAttribute('data-compare-price');
          var save          = btn.getAttribute('data-save');
          var title         = btn.getAttribute('data-title');
          var imgUrl        = btn.getAttribute('data-image');
          var priceMode     = btn.getAttribute('data-price-mode') || 'compare';
          var discountAmt   = btn.getAttribute('data-discount-amount') || '';
          var discountCode  = btn.getAttribute('data-discount-code') || '';

          if (info) {
            var productUrlLinks = info.querySelectorAll('[data-product-url]');
            productUrlLinks.forEach(function (a) {
              a.setAttribute('href', url || '#');
            });

            var ctaBtn = info.querySelector('[data-cta]');
            if (ctaBtn) ctaBtn.setAttribute('href', url || '#');

            var atcBtn = info.querySelector('[data-add-to-cart]');
            if (atcBtn && variantId) atcBtn.setAttribute('data-current-variant-id', variantId);

            var titleEl = info.querySelector('[data-variant-title]');
            if (titleEl && title) titleEl.textContent = title;

            var priceEl = info.querySelector('[data-variant-price]');
            if (priceEl && price) priceEl.textContent = price;

            var compareEl = info.querySelector('[data-variant-compare-price]');
            if (compareEl) {
              if (priceMode === 'compare' && comparePrice) { compareEl.textContent = comparePrice; compareEl.style.display = ''; }
              else                                         { compareEl.textContent = ''; compareEl.style.display = 'none'; }
            }

            var saveEl = info.querySelector('[data-variant-save]');
            if (saveEl) {
              if (priceMode === 'compare' && save) { saveEl.textContent = save; saveEl.style.display = ''; }
              else                                 { saveEl.textContent = ''; saveEl.style.display = 'none'; }
            }

            var codeRowEl = info.querySelector('[data-variant-code-row]');
            if (codeRowEl) {
              if (priceMode === 'code' && discountAmt) {
                var codeSaveEl = info.querySelector('[data-variant-code-save]');
                var codeTextEl = info.querySelector('[data-variant-code-text]');
                if (codeSaveEl) codeSaveEl.textContent = 'Save $' + discountAmt;
                if (codeTextEl) codeTextEl.innerHTML = discountCode ? 'with code <strong>' + discountCode + '</strong>' : '';
                codeRowEl.style.display = '';
              } else {
                codeRowEl.style.display = 'none';
              }
            }

            var descEl = info.querySelector('[data-variant-description]');
            if (descEl) {
              var desc  = btn.getAttribute('data-description') || '';
              var desc2 = btn.getAttribute('data-description2') || '';
              var combined = desc + (desc && desc2 ? '<br>' : '') + desc2;
              if (combined) { descEl.innerHTML = combined; descEl.style.display = ''; }
              else          { descEl.innerHTML = ''; descEl.style.display = 'none'; }
            }

            var badgeEl = info.querySelector('[data-product-badge]');
            if (badgeEl) {
              var badge = (btn.getAttribute('data-badge') || '').trim();
              if (badge) { badgeEl.textContent = badge; badgeEl.style.display = ''; }
              else       { badgeEl.textContent = ''; badgeEl.style.display = 'none'; }
            }
          }

          var productImg = (section || document).querySelector('[data-product-img]');
          if (productImg) {
            if (imgUrl) {
              productImg.style.opacity = '0';
              productImg.style.display = '';
              productImg.setAttribute('src', imgUrl);
              productImg.removeAttribute('srcset');
              productImg.onload = function () { productImg.style.opacity = '1'; };
            } else {
              productImg.style.display = 'none';
            }
          }
        });
      });
    });
  }

  /* --------------------------------------------------------------------------
     Section 3b: Add to Cart (Scenario Product Buy)
     -------------------------------------------------------------------------- */
  function initAddToCart() {
    var btns = document.querySelectorAll('.scenario-product-buy [data-add-to-cart]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('disabled')) return;

        var variantId = btn.getAttribute('data-current-variant-id');
        if (!variantId) {
          // No variant resolved (block has no product set) — fall back to product URL
          var info = btn.closest('.scenario-product-buy__info');
          var fallbackLink = info && info.querySelector('[data-product-url]');
          if (!fallbackLink) {
            fallbackLink = btn.parentElement && btn.parentElement.querySelector('[data-cta]');
          }
          if (fallbackLink && fallbackLink.getAttribute('href')) {
            window.location.href = fallbackLink.getAttribute('href');
          }
          return;
        }

        var labelEl = btn.querySelector('.scenario-product-buy__cta-label');
        var defaultLabel = btn.getAttribute('data-default-label') || (labelEl ? labelEl.textContent : '');
        var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-busy', 'true');
        if (labelEl) labelEl.textContent = 'Adding...';

        // Collect bundled sections (mirrors theme's ProductForm pattern so cart drawer auto-refreshes)
        var sectionsToBundle = ['variant-added'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        }));

        var formData = new FormData();
        formData.set('id', variantId);
        formData.set('quantity', '1');
        formData.set('sections', sectionsToBundle.join(','));
        formData.set('sections_url', routesRoot + 'variants/' + variantId);

        fetch(routesRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        }).then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        }).then(function (result) {
          if (!result.ok) {
            throw new Error((result.data && result.data.description) || 'Add to cart failed');
          }
          var addResp = result.data;
          var themeVars = window.themeVariables && window.themeVariables.settings;
          if (themeVars && (themeVars.cartType === 'page' || themeVars.pageType === 'cart')) {
            window.location.href = routesRoot + 'cart';
            return;
          }
          return fetch(routesRoot + 'cart.js').then(function (r) {
            return r.json();
          }).then(function (cartContent) {
            cartContent.sections = addResp.sections;
            btn.dispatchEvent(new CustomEvent('variant:add', {
              bubbles: true,
              detail: {
                items: addResp.items ? addResp.items : [addResp],
                cart: cartContent
              }
            }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'variant:add', cart: cartContent }
            }));
          });
        }).catch(function (err) {
          console.error('[scenario-product-buy] Add to cart error:', err);
          if (labelEl) labelEl.textContent = 'Try Again';
          setTimeout(function () {
            if (labelEl) labelEl.textContent = defaultLabel;
          }, 1800);
        }).finally(function () {
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-busy');
          // Restore label after a short delay so user sees "Added" feedback if you choose to add it later
          if (labelEl && labelEl.textContent === 'Adding...') {
            labelEl.textContent = defaultLabel;
          }
        });
      });
    });
  }

  /* --------------------------------------------------------------------------
     Section 4: Reviews Carousel
     -------------------------------------------------------------------------- */
  function initReviews() {
    var sections = document.querySelectorAll('.scenario-reviews');
    sections.forEach(function (section) {
      var track = section.querySelector('.scenario-reviews__track');
      var dotsEl = section.querySelectorAll('.scenario-reviews__dot');
      var total = section.querySelectorAll('.scenario-reviews__item').length;

      if (!track || total === 0) return;

      createCarousel({
        track: track,
        dots: Array.from(dotsEl),
        total: total,
        interval: 5000
      });
    });
  }

  /* --------------------------------------------------------------------------
     Section 5: FAQ Accordion
     -------------------------------------------------------------------------- */
  function initFAQ() {
    var faqs = document.querySelectorAll('.scenario-faq');
    faqs.forEach(function (faq) {
      var items = faq.querySelectorAll('.scenario-faq__item');
      items.forEach(function (item) {
        var question = item.querySelector('.scenario-faq__question');
        var answer = item.querySelector('.scenario-faq__answer');
        if (!question || !answer) return;

        question.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');

          // Close all
          items.forEach(function (other) {
            other.classList.remove('is-open');
            var otherAnswer = other.querySelector('.scenario-faq__answer');
            if (otherAnswer) otherAnswer.style.maxHeight = '0';
          });

          // Open clicked if it was closed
          if (!isOpen) {
            item.classList.add('is-open');
            answer.style.maxHeight = answer.scrollHeight + 'px';
          }
        });
      });
    });
  }

  /* --------------------------------------------------------------------------
     Section 6: Media Voices
     -------------------------------------------------------------------------- */
  function initMediaVoices() {
    var sections = document.querySelectorAll('.scenario-media');
    sections.forEach(function (section) {
      var logoBtns = section.querySelectorAll('.scenario-media__logo-btn');
      var quotes = section.querySelectorAll('.scenario-media__quote');
      var total = logoBtns.length;
      var current = 0;
      var timer = null;

      function showMedia(index) {
        current = (index + total) % total;
        logoBtns.forEach(function (btn, i) {
          btn.classList.toggle('is-active', i === current);
        });
        quotes.forEach(function (quote, i) {
          quote.classList.toggle('is-active', i === current);
        });
      }

      function startTimer() {
        stopTimer();
        timer = setInterval(function () {
          showMedia(current + 1);
        }, 3000);
      }

      function stopTimer() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      logoBtns.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          showMedia(i);
          stopTimer();
          startTimer();
        });
      });

      showMedia(0);
      startTimer();
    });
  }

  /* --------------------------------------------------------------------------
     Mobile Hotspot Modal
     Shows a full-screen product modal on touch devices instead of hover card
     -------------------------------------------------------------------------- */
  function initHotspotModal() {
    var backdrop = document.createElement('div');
    backdrop.className = 'scenario-hotspot-modal-backdrop';
    backdrop.innerHTML = [
      '<div class="scenario-hotspot-modal">',
        '<button class="scenario-hotspot-modal__close" aria-label="Close">\u00d7</button>',
        '<img class="scenario-hotspot-modal__img" src="" alt="">',
        '<div class="scenario-hotspot-modal__body">',
          '<p class="scenario-hotspot-modal__title"></p>',
          '<p class="scenario-hotspot-modal__price"></p>',
          '<div class="scenario-hotspot-modal__discount"></div>',
          '<a class="scenario-hotspot-modal__cta" href="#">Shop Now</a>',
        '</div>',
      '</div>'
    ].join('');
    document.body.appendChild(backdrop);

    var closeBtn    = backdrop.querySelector('.scenario-hotspot-modal__close');
    var imgEl       = backdrop.querySelector('.scenario-hotspot-modal__img');
    var titleEl     = backdrop.querySelector('.scenario-hotspot-modal__title');
    var priceEl     = backdrop.querySelector('.scenario-hotspot-modal__price');
    var discountEl  = backdrop.querySelector('.scenario-hotspot-modal__discount');
    var ctaEl       = backdrop.querySelector('.scenario-hotspot-modal__cta');

    function openModal(hs) {
      var card        = hs.querySelector('.scenario-scene__product-card');
      if (!card) return;
      var img         = card.querySelector('img');
      var name        = card.querySelector('.scenario-scene__product-card-name');
      var priceSpan   = card.querySelector('.scenario-scene__product-card-price');
      var compareSpan = card.querySelector('.scenario-scene__product-card-price-compare');
      var btn         = card.querySelector('.scenario-scene__product-card-btn');

      imgEl.src           = img  ? img.src          : '';
      imgEl.alt           = img  ? img.alt           : '';
      imgEl.style.display = img  ? ''                : 'none';
      titleEl.textContent = name ? name.textContent : '';
      priceEl.innerHTML = '';
      if (priceSpan) {
        var ps = document.createElement('span');
        ps.textContent = priceSpan.textContent;
        priceEl.appendChild(ps);
      }
      if (compareSpan) {
        var cs = document.createElement('span');
        cs.className = 'scenario-hotspot-modal__price-compare';
        cs.textContent = compareSpan.textContent;
        priceEl.appendChild(cs);
      }
      ctaEl.href = btn ? btn.href : '#';
      if (discountEl) {
        var saveSpan = card.querySelector('.scenario-scene__product-card-save');
        var codeSpan = card.querySelector('.scenario-scene__product-card-code');
        discountEl.innerHTML = '';
        if (saveSpan) {
          var ds = document.createElement('span');
          ds.className = 'scenario-hotspot-modal__save';
          ds.textContent = saveSpan.textContent;
          discountEl.appendChild(ds);
        }
        if (codeSpan) {
          var dc = document.createElement('span');
          dc.className = 'scenario-hotspot-modal__code';
          dc.textContent = codeSpan.textContent;
          discountEl.appendChild(dc);
        }
        discountEl.style.display = (saveSpan || codeSpan) ? '' : 'none';
      }
      backdrop.classList.add('is-open');
    }

    function closeModal() { backdrop.classList.remove('is-open'); }

    closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) closeModal();
    });

    var allHotspots = document.querySelectorAll('.scenario-scene__hotspot');

    allHotspots.forEach(function (hs) {
      /* Prevent card clicks from bubbling up and closing the card on desktop */
      var card = hs.querySelector('.scenario-scene__product-card');
      if (card) {
        card.addEventListener('click', function (e) { e.stopPropagation(); });
      }

      /* Desktop: hover shows card with grace period to bridge the dot→card gap */
      var hoverLeaveTimer = null;
      hs.addEventListener('mouseenter', function () {
        if (window.innerWidth > 900) {
          clearTimeout(hoverLeaveTimer);
          hs.classList.add('is-hover');
          var sceneSection = hs.closest('.scenario-scene');
          if (sceneSection && sceneSection._sceneCarousel) sceneSection._sceneCarousel.pause();
        }
      });
      hs.addEventListener('mouseleave', function () {
        if (window.innerWidth > 900) {
          hoverLeaveTimer = setTimeout(function () {
            hs.classList.remove('is-hover');
            var sceneSection = hs.closest('.scenario-scene');
            if (sceneSection && sceneSection._sceneCarousel) {
              var anyActive = Array.from(sceneSection.querySelectorAll('.scenario-scene__hotspot'))
                .some(function (h) { return h.classList.contains('is-hover'); });
              if (!anyActive) sceneSection._sceneCarousel.resume();
            }
          }, 300);
        }
      });

      hs.addEventListener('click', function (e) {
        if (window.innerWidth <= 900) {
          /* Mobile: open full-screen modal */
          e.preventDefault();
          openModal(hs);
        } else {
          /* Desktop: click-to-lock card open; click again or elsewhere to close */
          var wasOpen = hs.classList.contains('is-open');
          allHotspots.forEach(function (other) { other.classList.remove('is-open'); });
          if (!wasOpen) {
            hs.classList.add('is-open');
            e.stopPropagation(); /* prevent document listener from closing immediately */
          }
        }
      });
    });

    /* Desktop: click anywhere outside a hotspot closes all cards and resumes carousels */
    document.addEventListener('click', function () {
      allHotspots.forEach(function (hs) { hs.classList.remove('is-open'); hs.classList.remove('is-hover'); });
      document.querySelectorAll('.scenario-scene').forEach(function (s) {
        if (s._sceneCarousel) s._sceneCarousel.resume();
      });
    });
  }

  /* --------------------------------------------------------------------------
     Scenario Gifting Tabs: top Lover/Family panel switcher
     -------------------------------------------------------------------------- */
  function initGiftingTabs() {
    var sections = document.querySelectorAll('.scenario-gifting');
    sections.forEach(function (section) {
      var tabs = section.querySelectorAll('.scenario-gifting__tab');
      var panels = section.querySelectorAll('.scenario-gifting__panel');
      if (!tabs.length || !panels.length) return;

      function activate(scenarioKey) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-scenario') === scenarioKey;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-scenario') === scenarioKey;
          p.classList.toggle('is-active', on);
          if (on) p.removeAttribute('hidden');
          else    p.setAttribute('hidden', '');

          var sceneEl = p.querySelector('.scenario-gifting__scene');
          if (sceneEl && sceneEl._giftingScene) {
            if (on) {
              sceneEl._giftingScene.reset();
              sceneEl._giftingScene.resume();
            } else {
              sceneEl._giftingScene.pause();
            }
          }
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var scenarioKey = tab.getAttribute('data-scenario');
          if (scenarioKey) activate(scenarioKey);
        });
      });
    });
  }

  /* --------------------------------------------------------------------------
     Scenario Gifting Scenes: dots-only auto-rotate carousel inside each panel
     -------------------------------------------------------------------------- */
  function initGiftingScenes() {
    var scenes = document.querySelectorAll('.scenario-gifting__scene');
    scenes.forEach(function (scene) {
      var slides = scene.querySelectorAll('.scenario-scene__slide');
      var dots   = scene.querySelectorAll('.scenario-gifting__scene-dot');
      var total  = slides.length;

      if (total === 0) {
        scene._sceneCarousel = { pause: function () {}, resume: function () {} };
        scene._giftingScene  = { pause: function () {}, resume: function () {}, reset: function () {} };
        return;
      }

      if (total === 1) {
        slides[0].classList.add('is-active');
        scene._sceneCarousel = { pause: function () {}, resume: function () {} };
        scene._giftingScene  = { pause: function () {}, resume: function () {}, reset: function () {} };
        return;
      }

      var giftingSection = scene.closest('.scenario-gifting');
      var interval = parseInt((giftingSection && giftingSection.getAttribute('data-autoplay')) || '4000', 10) || 4000;
      var current = 0;
      var timer = null;

      function show(index) {
        current = (index + total) % total;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
        dots.forEach(function (d, i)   { d.classList.toggle('is-active', i === current); });
      }

      function start() {
        stop();
        timer = setInterval(function () { show(current + 1); }, interval);
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          show(i);
          start();
        });
      });

      var prevArrow = scene.querySelector('.scenario-gifting__scene-arrow--prev');
      var nextArrow = scene.querySelector('.scenario-gifting__scene-arrow--next');
      if (prevArrow) {
        prevArrow.addEventListener('click', function () { show(current - 1); start(); });
      }
      if (nextArrow) {
        nextArrow.addEventListener('click', function () { show(current + 1); start(); });
      }

      var slidesEl = scene.querySelector('.scenario-gifting__scene-slides');
      attachSwipe(slidesEl, function (dir) {
        show(current + dir);
        start();
      });

      // Pause on hover (desktop only)
      scene.addEventListener('mouseenter', function () {
        if (window.innerWidth > 900) stop();
      });
      scene.addEventListener('mouseleave', function () {
        if (window.innerWidth > 900) {
          var anyOpen = Array.prototype.some.call(
            scene.querySelectorAll('.scenario-scene__hotspot'),
            function (h) { return h.classList.contains('is-hover') || h.classList.contains('is-open'); }
          );
          if (!anyOpen) start();
        }
      });

      show(0);

      // Only auto-start if its panel is the initially-active one
      var panel = scene.closest('.scenario-gifting__panel');
      var initiallyActive = panel ? panel.classList.contains('is-active') : true;
      if (initiallyActive) start();

      // _sceneCarousel: matches the interface initHotspotModal expects on .scenario-scene
      scene._sceneCarousel = { pause: stop, resume: start };
      scene._giftingScene  = {
        pause:  stop,
        resume: start,
        reset:  function () { show(0); }
      };
    });
  }

  /* --------------------------------------------------------------------------
     Init all
     -------------------------------------------------------------------------- */
  function init() {
    if (window._scenarioInited) return;
    window._scenarioInited = true;
    initSceneCarousel();
    initGiftingScenes();
    initGiftingTabs();
    initProductGallery();
    initColorVariants();
    initAddToCart();
    initReviews();
    initFAQ();
    initMediaVoices();
    initHotspotModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
